<mat-sidenav-container class="contact-list__root container" [hasBackdrop]="true">
  <mat-sidenav class="fixed" #drawer [mode]="'over'" position="start">
    <app-organizations
      [profile]="profile() || undefined"
      (logout)="onLogout()"
      (close)="drawer.toggle()"
      (selected)="onOrganizationSelected($event)"
    ></app-organizations>
  </mat-sidenav>
  <section class="contact-list__root_logo-ctn header">
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="header__content">
          <div class="left">
            <button mat-icon-button (click)="drawer.toggle()" aria-label="Menu">
              <mat-icon>menu</mat-icon>
            </button>
            <h3>{{ currentOrganization()?.description }}</h3>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </section>
  <section class="contact-list">
    <app-dashboard-section-header
      [headerText]="usersHeaderText()"
      (addNew)="onAddUser()"
    >
      <form [formGroup]="searchForm" class="contact-list__root__search-ctn">
        <mat-form-field class="search full-width" appearance="outline" subscriptSizing="dynamic">
          <input matInput #searchInput placeholder="Search users" formControlName="search" />
          @if (searchForm.get('search')?.value) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Clear search"
              (click)="clearSearch(searchInput)"
            >
              <mat-icon>backspace</mat-icon>
            </button>
          } @else {
            <mat-icon matSuffix class="search-suffix-icon" aria-hidden="true">search</mat-icon>
          }
        </mat-form-field>
      </form>
      @if (usersLoading() !== true) {
        @if (filteredUsers().length > 0) {
          <mat-list class="contact-list__items contact-list__items--static">
            @for (user of filteredUsers(); track user.username) {
              <mat-list-item
                [lines]="showEmailSubtitle(user) ? 2 : 1"
                class="contact-list__items__item contact-list__items__item--location user-list-item"
              >
                <div matListItemTitle class="title user-list-item__title">
                  <div class="user-list-item__title-row">
                    <span class="user-list-item__name">{{ displayNameForList(user) }}</span>
                    <span
                      class="user-status-badge"
                      [class.user-status-badge--active]="accountStatusBadgeVariant(user) === 'active'"
                      [class.user-status-badge--disabled]="
                        accountStatusBadgeVariant(user) === 'disabled'
                      "
                      [class.user-status-badge--pending]="accountStatusBadgeVariant(user) === 'pending'"
                      [class.user-status-badge--neutral]="accountStatusBadgeVariant(user) === 'neutral'"
                    >
                      {{ accountStatusLabel(user) }}
                    </span>
                  </div>
                </div>
                @if (showEmailSubtitle(user)) {
                  <div matListItemLine class="title gray-color user-list-item__email">{{
                    user.email
                  }}</div>
                }
                <div matListItemMeta class="actions menu-container">
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="User actions"
                    [matMenuTriggerFor]="userMenu"
                    (click)="$event.stopPropagation()"
                  >
                    <mat-icon>more_horiz</mat-icon>
                  </button>
                  <mat-menu #userMenu="matMenu" xPosition="before">
                    <button mat-menu-item (click)="onEditUser(user)" [disabled]="!canEditUser(user)">
                      <mat-icon>edit</mat-icon>
                      <span>Edit user</span>
                    </button>
                    @if (canResetPassword(user)) {
                      <button mat-menu-item (click)="onResetPassword(user)">
                        <mat-icon>lock_reset</mat-icon>
                        <span>Reset password</span>
                      </button>
                    }
                    @if (canEnableUser(user)) {
                      <button mat-menu-item (click)="onEnableUser(user)">
                        <mat-icon>person</mat-icon>
                        <span>Enable user</span>
                      </button>
                    }
                    @if (canDisableUser(user)) {
                      <button mat-menu-item (click)="onDisableUser(user)">
                        <mat-icon>person_off</mat-icon>
                        <span>Disable user</span>
                      </button>
                    }
                  </mat-menu>
                </div>
              </mat-list-item>
            }
          </mat-list>
        } @else if (usersCount() === 0) {
          <p class="empty-message">There are no users in this organization.</p>
        } @else {
          <p class="empty-message">No users match your search.</p>
        }
      } @else {
        <ng-container *ngTemplateOutlet="loadUsers"></ng-container>
      }
    </app-dashboard-section-header>
  </section>
</mat-sidenav-container>
<ng-template #loadUsers>
  <div class="loading">
    <mat-card appearance="outlined" class="place_holder">
      <mat-card-content>
        <app-skeleton
          viewBox="0 0 150 24"
          [speed]="2"
          backgroundColor="#E0DCDC"
          foregroundColor="rgba(0, 0, 0, 0.1)"
        >
          <svg:rect x="3" y="0" rx="0" ry="0" width="50%" height="9" />
          <svg:rect x="3" y="12" rx="0" ry="0" width="35%" height="9" />
        </app-skeleton>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
